import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AppStateService } from '../../services/app-state.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-printing-partner',
  templateUrl: './printing-partner.component.html'
})
export class PrintingPartnerComponent {
  form: FormGroup;
  isSubmitting = false;

  iAmOptions = [
    'Photographer',
    'Painting / Digital / any other artist',
    'Looking for exhibition / events',
    'Curator'
  ];

  requirementOptions = ['Now', '1-3 Months', '3-6 months', 'After 6 months'];

  constructor(private fb: FormBuilder, private http: HttpClient, private state: AppStateService) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contact: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      password: ['', [Validators.required, Validators.minLength(4)]],
      i_am: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      requirement: ['', Validators.required]
    });
  }

  submit() {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;
    this.http.post(`${environment.apiUrl}/api/unauth/printing-partner`, this.form.value).subscribe(
      () => {
        this.state.showToast('Submitted successfully!', 'success');
        this.form.reset();
        this.isSubmitting = false;
      },
      () => {
        this.state.showToast('Something went wrong. Please try again.', 'info');
        this.isSubmitting = false;
      }
    );
  }
}
